angular.module('leanlaw').filter("includeInactive", function () {
  return function (list, include) {
    return list && list.filter(item => {
      return item?.active === include;
    });
  };
}).filter("excludePrimary", function () {
  return function (list) {
    return list && list.filter(item => {
      return !item.primary;
    });
  };
}).filter("onlyOriginating", function () {
  return function (list) {
    return list && list.filter(item => {
      return item.originating && !item.primary;
    });
  };
});